import React, { useEffect } from 'react';
import InputTextComp from "@components/UI/InputText/Index.jsx";
import { SaveItemProcesso } from "@services/ItensProcesso/Index.jsx";
import { useForm } from 'react-hook-form';
import ButtonComp from "@components/UI/Button/Index.jsx";
import SweetAlert from "@components/Feedback/SweetAlert/Index.jsx";
import SelectOptionComp from '@components/UI/SelectOption/Index.jsx';
import { etapaProcessoOptions } from "@enums/EtapasProcesso/Index.jsx";
import { blockedOptionMessage } from '@utils/Index.jsx';
import { useFetchDataCascade } from '@hooks/api/useFetchDataCascade.js';

const Create = ({ onSave }) => {

    const {
        register,
        handleSubmit,
        reset,
        setValue,
        watch,
    } = useForm({
        defaultValues: {
            ano: null,
            servico: null,
            tipo: null,
            nomeProcesso: null,
            etapaProcesso: null,
            nomeItem: "",
            descricao: "",
        },
    });

    const {
        yearOptions,
        serviceOptions,
        typeOptions,
        processOptions,
        yearLoading,
        serviceLoading,
        typeLoading,
        processLoading,
        fetchYears,
        fetchServicesByYear,
        fetchTypesByServiceId,
        fetchProcessosByType,
        setServiceOptions,
        setTypeOptions,
        setProcessOptions,
    } = useFetchDataCascade();

    const onSubmit = async (data) => {
        try {
            SweetAlert.loading();

            const payload = {
                idProcesso: data?.nomeProcesso?.value,
                nomeItem: data?.nomeItem,
                descricao: data.descricao,
                etapaProcesso: data.etapaProcesso?.value,
                flgStatus: true,
            };

            const result = await SaveItemProcesso(payload);

            SweetAlert.success('Cadastro Realizado!', 'Os dados foram salvos com sucesso.');

            onSave({ ...result });

            reset({
                ano: null,
                servico: null,
                tipo: null,
                nomeProcesso: null,
                etapaProcesso: null,
                nomeItem: "",
                descricao: "",
            });

        } catch (error) {
            const errorMessage = error.parsed?.message || 'Não foi possível salvar o item do processo.';

            SweetAlert.errorHTML('Erro ao cadastrar', errorMessage);
            console.error(error);
        }
    };

    const ano = watch("ano");
    const servico = watch("servico");
    const tipo = watch("tipo");
    const nomeProcesso = watch("nomeProcesso");
    const etapa = watch("etapa");
    const nomeItem = watch("nomeItem");

    useEffect(() => {
        fetchYears();
    }, []);

    useEffect(() => {
        const selectedYear = ano?.value;

        if (selectedYear) {
            setValue("servico", null);
            setValue("tipo", null);
            setValue("nomeProcesso", null);
            setValue("etapaProcesso", null);
            setValue("nomeItem", "");
            setValue("descricao", "");
            fetchServicesByYear(selectedYear);
        } else {
            setServiceOptions([]);
            setTypeOptions([]);
            setProcessOptions([]);
        }
    }, [ano]);

    useEffect(() => {
        const selectedServiceId = servico?.value;

        if (selectedServiceId) {
            setValue("tipo", null);
            setValue("nomeProcesso", null);
            setValue("etapaProcesso", null);
            setValue("nomeItem", "");
            setValue("descricao", "");
            fetchTypesByServiceId(selectedServiceId);
        } else {
            setTypeOptions([]);
            setProcessOptions([]);
        }
    }, [servico]);

    useEffect(() => {
        if (tipo?.value) {
            setValue("nomeProcesso", null);
            setValue("etapaProcesso", null);
            setValue("nomeItem", "");
            setValue("descricao", "");
            fetchProcessosByType(tipo.value);
        } else {
            setProcessOptions([]);
        }
    }, [tipo]);

    useEffect(() => {
        if (nomeProcesso?.value) {
            setValue("etapaProcesso", null);
            setValue("nomeItem", "");
            setValue("descricao", "");
        } else {
            setValue("etapaProcesso", null);
            setValue("nomeItem", "");
            setValue("descricao", "");
        }
    }, [nomeProcesso]);

    useEffect(() => {
        if (etapa?.value) {
            setValue("nomeItem", "");
            setValue("descricao", "");
        } else {
            setValue("nomeItem", "");
            setValue("descricao", "");
        }
    }, [etapa]);

    useEffect(() => {
        if (!nomeItem) {
            setValue("descricao", "");
        }
    }, [nomeItem]);


    return (
        <form onSubmit={handleSubmit(onSubmit)} className='form'>
            <div className="row">

                <div className="p-3">
                    <h3> - Observação: Os campos serão habilitados conforme o preenchimento do atual campo habilitado. </h3>
                </div>

                <div className="col-5 col-md-5">

                    <SelectOptionComp
                        label="Ano"
                        options={yearOptions}
                        value={watch("ano")}
                        onChange={(selected) => setValue("ano", selected)}
                        placeholder="Selecionar um ano"
                        hoverMessage="Selecionar um ano"
                        isLoading={yearLoading}
                        required
                    />

                </div>

                <div className="col-8 col-md-8">

                    <SelectOptionComp
                        label="Serviço"
                        options={serviceOptions}
                        value={watch("servico")}
                        onChange={(selected) => setValue("servico", selected)}
                        placeholder={watch("ano") ? "Selecionar um serviço" : blockedOptionMessage}
                        hoverMessage="Selecionar um serviço"
                        isDisabled={!watch("ano")}
                        isLoading={serviceLoading}
                        required
                    />

                    <SelectOptionComp
                        label="Tipo"
                        options={typeOptions}
                        value={watch("tipo")}
                        onChange={(selected) => setValue("tipo", selected)}
                        placeholder={watch("servico") ? "Selecionar um tipo" : blockedOptionMessage}
                        hoverMessage="Selecionar um tipo"
                        isDisabled={!watch("servico")}
                        isLoading={typeLoading}
                        required
                    />

                    <SelectOptionComp
                        label="Processo"
                        options={processOptions}
                        value={watch("nomeProcesso")}
                        onChange={(selected) => setValue("nomeProcesso", selected)}
                        placeholder={watch("tipo") ? "Selecionar um processo" : blockedOptionMessage}
                        hoverMessage="Selecionar um processo"
                        isDisabled={!watch("tipo")}
                        isLoading={processLoading}
                        required
                    />

                    <SelectOptionComp
                        label="Etapa do Processo"
                        options={etapaProcessoOptions}
                        value={watch("etapaProcesso")}
                        onChange={(selected) => setValue("etapaProcesso", selected || null)}
                        placeholder={watch("nomeProcesso") ? "Selecionar uma etapa do processo" : blockedOptionMessage}
                        hoverMessage="Selecionar uma etapa do processo"
                        isDisabled={!watch("nomeProcesso")}
                        required={true}
                    />

                    <InputTextComp
                        label="Item do Processo"
                        name="nomeItem"
                        {...register("nomeItem")}
                        placeholder={watch("etapaProcesso") ? "Preencher com um item do processo" : blockedOptionMessage}
                        hoverMessage="Preencher com um item do processo"
                        maxLength={255}
                        disabled={!watch("etapaProcesso")}
                        required={true}
                    />

                    <InputTextComp
                        label="Descrição"
                        name="descricao"
                        {...register("descricao")}
                        placeholder={watch("nomeItem") ? "Preencher com uma descrição" : blockedOptionMessage}
                        hoverMessage="Preencher com uma descrição"
                        maxLength={255}
                        disabled={!watch("nomeItem")}
                        required={true}
                    />

                </div>

                <div className="col-md-8 mt-4">

                    <ButtonComp
                        title="SALVAR"
                        type="submit"
                        buttonColor="#2b97be"
                        classnameIcon="fa-regular fa-floppy-disk"
                        hoverMessage={"Botão para confirmar o cadastro"}
                    />

                </div>
            </div>
        </form>
    );
};

export default Create;
